import { MerchantStoreStatusRequestDto as MerchantStatusRequestDto } from '../../../../models/lokal/merchant-status-request';
import { MerchantService } from './../../../../services/merchant.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  NgZone,
  OnDestroy,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { SplashScreenStateService, ZohoSignService } from 'app/services';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AnimationOptions, BMCompleteLoopEvent } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';
import { MerchantStatusEnum } from 'app/models';

@Component({
  selector: 'merchant-sign-contract',
  templateUrl: './merchant-sign-contract.component.html',
  styleUrls: ['./merchant-sign-contract.component.scss'],
  providers: [MessageService],
})
export class MerchantSignContractComponent implements OnInit, OnDestroy {
  @Input()
  public merchanUser: any = {};

  public isEmailPopupVisible: boolean = false;
  public merchanEmail: string = '';

  public merchantContractFormUrl: SafeResourceUrl | undefined = undefined;

  public isZohoSignFormVisible: boolean = false;

  public isSpinnerVisible: boolean = false;

  public showSplash: boolean = false;

  public signInTab: Window | null = null;

  private visibilityChangeHandler!: () => void;

  loading = false;

  isResumable = false;

  isVerifyingSignIn = false;

  public options: AnimationOptions = {
    path: '/XpressApp/assets/animation/97078.json',
    autoplay: true,
    loop: true,
  };

  public styles: Partial<CSSStyleDeclaration> = {
    top: '0',
    left: '0',
    position: 'fixed',
    zIndex: '10000',
  };

  animationItem!: AnimationItem;

  @Output() changedMerchantSignContractEmit = new EventEmitter<boolean>();
  changedMerchantSignContract(increased: any) {
    this.changedMerchantSignContractEmit.emit(increased);
  }

  constructor(
    private ngZone: NgZone,
    private messageService: MessageService,
    private zohoSignService: ZohoSignService,
    private sanitizer: DomSanitizer,
    private splashScreenStateService: SplashScreenStateService,
    private dialog: MatDialog,
    private merchantService: MerchantService
  ) {}

  ngOnInit(): void {
    this.merchanEmail =
      this.merchanUser.BusinessEmail || this.merchanUser.Email;
    //this.getFormUrl(); TODO: Enable when ZOHO Sign is avail
  }

  ngOnDestroy(): void {
    document.removeEventListener(
      'visibilitychange',
      this.visibilityChangeHandler
    );
  }
  animationCreated(animationItem: AnimationItem): void {
    NgZone.assertInAngularZone();
    this.animationItem = animationItem;
  }

  loopComplete(e: BMCompleteLoopEvent) {
    this.isEmailPopupVisible = true;
    this.showSplash = false;

    this.ngZone.runOutsideAngular(() => {
      this.animationItem?.stop();
    });
  }

  public handleCompleteSigningClick(): void {
    this.showSplash = true;
    this.ngZone.runOutsideAngular(() => {
      this.animationItem?.play();
    });
  }

  public handleEmailPopupCancelClick(): void {
    // Close EmailPopup
    this.isEmailPopupVisible = false;
  }

  public getFormUrl() {
    this.isVerifyingSignIn = true;
    const dto = {
      MerchantId: this.merchanUser.MerchantId,
      MerchantName: this.merchanUser.TradingName,
      MerchantEmail: this.merchanUser.BusinessEmail,
    };

    this.zohoSignService
      .getMerchantContractFormUrl(dto, this.messageService)
      .then((data) => {
        this.splashScreenStateService.stop();
        this.isVerifyingSignIn = false;

        if (!data) {
          return;
        }

        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }

        if (data.IsSigned) {
          this.isResumable = data.IsSigned;
        } else {
          if (this.visibilityChangeHandler) {
            document.removeEventListener(
              'visibilitychange',
              this.visibilityChangeHandler
            );
          }
        }
      });
  }

  public handleEmailPopupContinueClick() {
    if (!this.merchanUser.BusinessEmail) {
      return;
    }

    this.splashScreenStateService.start();

    // Close EmailPopup
    // this.isEmailPopupVisible = false;

    const dto = {
      MerchantId: this.merchanUser.MerchantId,
      MerchantName: this.merchanUser.TradingName,
      MerchantEmail: this.merchanUser.BusinessEmail,
    };

    this.zohoSignService
      .getMerchantContractFormUrl(dto, this.messageService)
      .then((data) => {
        this.splashScreenStateService.stop();

        if (!data) {
          return;
        }

        if (!data.Success) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: data.ErrorMessage,
          });
          return;
        }

        if (data.IsSigned) {
          this.isResumable = data.IsSigned;
          this.dialog.open(MessageDialogComponent);
        } else {
          // Variant with SignForm template
          //data.ZohoSignMerchantContractFormUrl += `&recipient_email=${this.merchanEmail}`; // &recipient_name=${this.merchanUser.TradingName}
          this.merchantContractFormUrl =
            this.sanitizer.bypassSecurityTrustResourceUrl(
              data.ZohoSignMerchantContractFormUrl
            );

          // Show ZohoSignForm iframe
          this.isZohoSignFormVisible = true;

          // Varian redirect
          // this.signInTab = window.open(
          //   encodeURI(data.ZohoSignMerchantContractFormUrl)
          // );

          this.addEventVisibleListener();
        }
      });
  }

  public handleZohoSignFormLoad(): void {
    const signiframe: HTMLIFrameElement = document.getElementById(
      'zohoSignForm'
    ) as HTMLIFrameElement;
    if (!signiframe || !signiframe.contentWindow) {
      return;
    }
    // DOMException: Blocked a frame with origin from accessing a cross-origin frame
    //console.log(signiframe.contentWindow.document.getElementById('continue-group'));
  }

  addEventVisibleListener() {
    //Add Event Visible Listner
    this.visibilityChangeHandler = () => {
      if (document.visibilityState === 'visible') {
        if (!this.isResumable) {
          this.getFormUrl();
        }
        // Add logic for when the tab becomes visible
      }
    };

    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
  }

  public openChatSideBar() {
    this.changedMerchantSignContract(true);
  }

  resume() {
    this.loading = true;
    const payload: MerchantStatusRequestDto = {
      MerchantId: this.merchanUser.MerchantId,
      StatusId: MerchantStatusEnum.WelcomePage,
    };
    this.merchantService
      .merchantStatusChange(payload, this.messageService)
      .then((data) => {
        location.reload();
      });
  }

  onCloseSigning() {
    this.isZohoSignFormVisible = !this.isZohoSignFormVisible;
    this.getFormUrl();
  }
}
